export default __webpack_public_path__ + "static/media/about-img.58d2ebe7.svg";